"use strict";

exports.__esModule = true;
exports.default = void 0;

var _schema = _interopRequireDefault(require("./section/schema"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = {
  "type": "object",
  "properties": {
    "locale": {
      "type": "string",
      "default": "no"
    },
    "schemaId": {
      "type": "number",
      "default": 1
    },
    "title": {
      "type": "string"
    },
    "content": {
      "type": "object",
      "properties": {
        "location": {
          "type": "geopoint"
        },
        "keywords": {
          "type": "array",
          "items": {
            "type": "string",
            "enum": []
          },
          "uniqueItems": true
        },
        "license": {
          "type": "string"
        },
        "headerImage": {
          "type": "image"
        },
        "title": {
          "type": "localizedString"
        },
        "leadtext": {
          "type": "localizedString"
        },
        "bodytext": {
          "type": "localizedString"
        },
        "sections": {
          "type": "array",
          "items": _schema.default
        },
        "isPartOf": {
          "type": "array",
          "items": {
            "type": "reference",
            "documentType": "topic",
            "referenceType": "articleIsPartOf",
            "_reverseReferenceType": "topicHasArticles",
            "_reverseReference": "hasArticles[]"
          }
        }
      }
    }
  }
};
exports.default = _default;
module.exports = exports.default;